module.exports = __webpack_public_path__ + "img/img2.84c4df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img2.png
// module id = 196
// module chunks = 0